import React from 'react';
import PropTypes from 'prop-types';
import UserAccount from '../../services/UserAccount';
import WindowSize from '../../services/WindowSize';
import Popup from '../Popup/index';
import Constants from '../../submodules/logictry_config/constants';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import { CancelButton, Card, ConfirmButton, DialogActions, LogoHeader, Subtitle, Title, WarningText, SecondaryTextButton } from '../../styledhtml/Tailwind';


export default class ConfirmDialog extends LogictryComponent {
  static propTypes = {
    open: PropTypes.bool,
    onNo: PropTypes.func,
    onYes: PropTypes.func,
    onOk: PropTypes.func,
    text: PropTypes.string,
    description: PropTypes.any,
    form: PropTypes.node,
    allowBackgroundClose: PropTypes.bool,
    warning: PropTypes.string,
    secondaryTextButton: PropTypes.string,
    onSecondaryTextButton: PropTypes.func,
  };

  componentDidMount() {
    WindowSize.onStateUpdate(this);
  }

  componentWillUnmount() {
    WindowSize.offStateUpdate(this);
  }

  render() {
    const {
      open,
      onNo,
      onYes,
      onOk,
      text,
      description,
      form,
      allowBackgroundClose,
      warning,
      secondaryTextButton,
      onSecondaryTextButton,
    } = this.props;

    if (!open) return null;

    return (
      <Popup
        showCloseButton={allowBackgroundClose}
        allowBackgroundClose={allowBackgroundClose}
        onClose={() => {
          if (!allowBackgroundClose) return;
          if (onNo) onNo();
          if (onOk) onOk();
        }}
      >
        <Card style={{ width: 420 }} onClick={(e) => e.stopPropagation()}>
          {/* Logo just like the other popups */}
          {!UserAccount.isLoggedIn && <LogoHeader>
            <img src={Constants.Logo} alt="Logictry" />
          </LogoHeader>}

          <Title>{text}</Title>

          {description && <Subtitle>{description}</Subtitle>}

          {form}

          {warning && <WarningText>{warning}</WarningText>}

          <DialogActions>
            {onNo && (
              <CancelButton onClick={onNo}>
                No
              </CancelButton>
            )}

            {onYes && (
              <ConfirmButton onClick={onYes}>
                Yes
              </ConfirmButton>
            )}

            {onOk && (
              <ConfirmButton onClick={onOk}>
                OK
              </ConfirmButton>
            )}
          </DialogActions>
          {secondaryTextButton && (
            <DialogActions style={{ marginTop: '1rem' }}>
              <SecondaryTextButton onClick={onSecondaryTextButton}>
                {secondaryTextButton}
              </SecondaryTextButton>
            </DialogActions>
          )}
        </Card>
      </Popup>
    );
  }
}
